import { SidebarHeader } from '@pocketlaw/tetris';
import { MetadataNotifications } from 'app/domains/metadata';
import { NavigationMenu } from './NavigationMenu';
import { UniversalSearch } from './UniversalSearch';
import { StyledLogoType, StyledDesktopSidebar, StyledLink, AlignRight } from './styled';
export function Desktop() {
    return (<StyledDesktopSidebar>
      <SidebarHeader>
        <StyledLink to="/dashboard">
          <StyledLogoType />
        </StyledLink>
        <AlignRight>
          <MetadataNotifications />
        </AlignRight>
      </SidebarHeader>
      <UniversalSearch />
      <NavigationMenu />
    </StyledDesktopSidebar>);
}
